import React, { useEffect, useState } from 'react'
import { ResponsiveContainer } from 'recharts'
import { Typography, Box } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'

import { Moment } from 'config/moment'
import { ERRORS } from 'consts'
import { snackbar } from 'components'
import { useApiCall } from 'hooks'

import {
  DataUserStatusDashboad,
  GetDataUserStatusDashboadResponse,
  ParametersDownload,
} from '../types'
import { getUserFrequency } from '../api'
import { CustomPieChart } from './CustomPieChart'

interface propsUsersStatus {
  startDate: Moment
  endDate: Moment
}

const UserFrequency: React.FC<propsUsersStatus> = ({ startDate, endDate }) => {
  const [data2, setData] = useState<DataUserStatusDashboad[] | []>([])
  const [requestUsersTags] = useApiCall<ParametersDownload, GetDataUserStatusDashboadResponse>(() =>
    getUserFrequency({ startDate, endDate }),
  )

  useEffect(() => {
    requestUsersTags({ startDate, endDate })
      .then(resp => {
        setData(resp.data.filter(obj => obj.value > 0))
      })
      .catch(() => {
        setData([])
        snackbar.show(ERRORS.GENERIC_ERROR_MESSAGE)
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate])

  return (
    <Grid
      container
      item
      spacing={2}
      md={12}
      style={{
        background: '#fff',
        boxShadow: '0 2px 7px 0 rgba(0,0,0,.06)',
        paddingTop: 20,
        paddingBottom: 20,
      }}
    >
      <Grid item sm={12} md={8}>
        <ResponsiveContainer width="100%">
          <CustomPieChart data={data2} title="" />
        </ResponsiveContainer>
      </Grid>
      <Grid item sm={12} md={4}>
        <Typography component="div" color="textSecondary" style={{}}>
          <Box fontWeight="fontWeightMedium" display="inline">
            {' '}
            Fan:
          </Box>{' '}
          Fan: registra 5 o más escaneos en los últimos 3 meses
        </Typography>
        <Typography component="div" color="textSecondary" style={{ marginTop: 20 }}>
          <Box fontWeight="fontWeightMedium" display="inline">
            {' '}
            Frecuente:
          </Box>{' '}
          registra entre 2 y 4 escaneos en los últimos 3 meses
        </Typography>
        <Typography component="div" color="textSecondary" style={{ marginTop: 20 }}>
          <Box fontWeight="fontWeightMedium" display="inline">
            {' '}
            One Hit:
          </Box>{' '}
          registra 1 escaneo en los últimos 3 meses
        </Typography>
      </Grid>
    </Grid>
  )
}
export { UserFrequency }
